import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { getQueryParams, splitArray } from '../../services/UtilityService';
import { useAssessments } from '../../hooks/AssessmentProvider';
import TeammapService from '../../services/TeammapService';
import AllMembersList from './teammap/AllMembersList';

const TRANSLATIONS = {
    en: {
        title: 'Team Map',
        colGenius: 'Working Genius',
        colCompetency: 'Working Competency',
        colFrustration: 'Working Frustration',
        tieText: '* Represents a tie of 4 or more',
    },
    es: {
        title: 'Mapa del Equipo',
        colGenius: 'Genios en acción',
        colCompetency: 'Genialidades en las que soy competente',
        colFrustration: 'Genialidades que me frustran',
        tieText: '* Representa un empate de 4 o más',
    },
    de: {
        title: 'Team-Karte',
        colGenius: 'Geniusgenie',
        colCompetency: 'Arbeitskompetenz',
        colFrustration: 'Frust am Arbeitsplatz',
        tieText: '* Steht für einen Gleichstand von 4 oder mehr',
    },
};

const TeamMapReport = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const {
		teamMap: { label, members, endText },
    setTeamMap
	} = useAssessments();

	const location = useLocation();
	const params = getQueryParams(location.search);
	const t = TRANSLATIONS[params.language] || TRANSLATIONS.en;

	useEffect(() => {
		setTeamMap({});
		setError('');
		setLoading(true);
		TeammapService.getReportData(params)
			.then((data) => {
				const allMembers = [...data.data];
				const members = splitArray(allMembers, 10);
				const label = data.label;
				const hasTiesWithFourOrMore =
					allMembers.filter((m) => {
						if (!m.ties) {
							return false;
						}
						let has = false;
						Object.keys(m.ties).forEach((key) => {
							has = has || m.ties[key].length >= 4;
						});
						return has;
					}).length > 0;
				const endText = hasTiesWithFourOrMore ? t.tieText : '';
				setTeamMap({
					endText,
					members,
					label,
				});
			})
			.catch((err) => setError(err))
			.finally(() => setLoading(false));
	}, []);

	const renderContent = () => {
		return loading || error ? null : (
			<>
				{members.map((memberList, idx) => (
					<AllMembersList
						members={memberList}
						label={label}
						key={idx}
						endText={idx === members.length - 1 ? endText : ''}
						t={t}
						lang={params.language}
					/>
				))}
			</>
		);
	};

	return (
		<>
			<Helmet>
				<meta charSet='UTF-8' />
				<meta name='viewport' content='width=device-width, initial-scale=1.0' />
				<meta httpEquiv='X-UA-Compatible' content='ie=edge' />
				<title>The 6 Types of Working Genius Team Map Report</title>
				<link rel='stylesheet' href='/report/teampdf.css' />
			</Helmet>
			{renderContent()}
		</>
	);
};

export default TeamMapReport;
